import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { UnitListComponent } from './unit-list/unit-list.component';
import { UnitAddComponent } from './unit-add/unit-add.component';
import { UnitEditComponent } from './unit-edit/unit-edit.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { ChecklistUnitComponent } from './checklist-unit/checklist-unit.component';
import { ListChecklistUnitComponent } from './list-checklist-unit/list-checklist-unit.component';
import { FuelConsumptionComponent } from './fuel-consumption/fuel-consumption.component';

const routes: Routes = [{
    path: "unit", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "list", component: UnitListComponent, data: { module: "Unidad", accion: "Listado de Unidades", type: "list" }
    }, {
        path: "add", component: UnitAddComponent, data: { module: "Unidad", accion: "Creación de Unidad", type: "add" }
    }, {
        path: "update/:id", component: UnitEditComponent, data: { module: "Unidad", accion: "Actualización de Unidad", type: "update" }
    }, {
        path: "checklist", component: ChecklistUnitComponent, data: { module: "Unidad", accion: "Checklist de Unidad", type: "checklist" }
    }, {
        path: "list-checklist/:id", component: ListChecklistUnitComponent, data: { module: "Unidad", accion: "Listado de Checklists", type: "list-checklist" }
    }, {
        path: "fuel-consumption", component: FuelConsumptionComponent, data: { module: "Unidad", accion: "Registro de consumo", type: "fuel-consumption" }
    }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnitRoutingModule { }